export const APP_NAME = 'splashy';

export const PageName = {
  BURNOUT: 'burnout',
};

export enum StorageItems {
  USER_INFO = 'user_info',
  APP_LANGUAGE = 'app_language',
  TIMEZONE = 'timezone',
  REPORT_PENDING = 'report_pending',
  FEEDBACK_MODAL_CLOSE = 'feedback_modal_close',
  DASHBOARD_VERSION = 'dashboard_version',
  ACCESS_TOKEN = 'MFA_ACCESS_TOKEN',
  MAX_API = 'MAX_API',
  TEMP_TOKEN = 'TEMP_TOKEN',
  TOKEN_VALID = 'TOKEN_VALID',
  DEVICE_ID = 'device_id',
  SESSION_HINT = 'session_active',
  VITE_PRELOAD_ERROR_LAST_RELOAD = 'vite:preloadErrorLastReload',
  AI_CHAT_CONSENT = 'ai_chat_consent',
}

export enum OrganisationTeamMemberRole {
  admin_member = '1',
  admin = '2',
}
